import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "dd7bd5a6-2f4c-4126-b1ed-20c63f66aad0"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooterDd7bd5a62f4c4126B1ed20c63f66aad0(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooterDd7bd5a62f4c4126B1ed20c63f66aad0 footer`}>
      {props["links"] || <Navigation className="Links45dc7d854b974b858d7aE3944c7d6f24" parentTag={buildClassName("Links45dc7d854b974b858d7aE3944c7d6f24", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo08423b2c9c6d4afd835aE9a158f4a808" parentTag={buildClassName("Logo08423b2c9c6d4afd835aE9a158f4a808", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightA07c6e9dEc7446239b1fB6aa89c99284" parentTag={buildClassName("CopyrightA07c6e9dEc7446239b1fB6aa89c99284", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow6b7e20208884402bA3562cd55c490695" parentTag={buildClassName("Groupflow6b7e20208884402bA3562cd55c490695", parentTag)} {...props} />}
    </footer>
  );
}

// id: "08423b2c-9c6d-4afd-835a-e9a158f4a808"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "dd7bd5a6-2f4c-4126-b1ed-20c63f66aad0"
export function Logo08423b2c9c6d4afd835aE9a158f4a808(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo08423b2c9c6d4afd835aE9a158f4a808" parentTag={buildClassName("Logo08423b2c9c6d4afd835aE9a158f4a808", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "a07c6e9d-ec74-4623-9b1f-b6aa89c99284"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "dd7bd5a6-2f4c-4126-b1ed-20c63f66aad0"
export function CopyrightA07c6e9dEc7446239b1fB6aa89c99284(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightA07c6e9dEc7446239b1fB6aa89c99284" parentTag={buildClassName("CopyrightA07c6e9dEc7446239b1fB6aa89c99284", parentTag)} {...props} />
  );
}

// id: "45dc7d85-4b97-4b85-8d7a-e3944c7d6f24"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "dd7bd5a6-2f4c-4126-b1ed-20c63f66aad0"
export function Links45dc7d854b974b858d7aE3944c7d6f24(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links45dc7d854b974b858d7aE3944c7d6f24" parentTag={buildClassName("Links45dc7d854b974b858d7aE3944c7d6f24", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "6b7e2020-8884-402b-a356-2cd55c490695"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "dd7bd5a6-2f4c-4126-b1ed-20c63f66aad0"
export function Groupflow6b7e20208884402bA3562cd55c490695(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow6b7e20208884402bA3562cd55c490695" parentTag={buildClassName("Groupflow6b7e20208884402bA3562cd55c490695", parentTag)} {...props} />
  );
}

// id: "d44be266-3dc9-49cd-887b-93fc797b0b4c"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "08423b2c-9c6d-4afd-835a-e9a158f4a808"
export const LogoTypeD44be2663dc949cd887b93fc797b0b4c = "FOOTER";

// id: "f955c9ec-e4aa-4e12-8859-09c92ba7c43e"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "45dc7d85-4b97-4b85-8d7a-e3944c7d6f24"
export const NavMenuSlugF955c9ecE4aa4e12885909c92ba7c43e = "footer-nav";

// id: "f23cab68-5b7b-482a-b1ce-13ce4d32bccb"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "08423b2c-9c6d-4afd-835a-e9a158f4a808"
export const ContentSlugF23cab685b7b482aB1ce13ce4d32bccb = "footer-logo";

const Components = {
  DefaultFooterDd7bd5a62f4c4126B1ed20c63f66aad0,
  Logo08423b2c9c6d4afd835aE9a158f4a808,
  CopyrightA07c6e9dEc7446239b1fB6aa89c99284,
  Links45dc7d854b974b858d7aE3944c7d6f24,
  Groupflow6b7e20208884402bA3562cd55c490695,
  LogoTypeD44be2663dc949cd887b93fc797b0b4c,
  NavMenuSlugF955c9ecE4aa4e12885909c92ba7c43e,
  ContentSlugF23cab685b7b482aB1ce13ce4d32bccb
}

export default Components;